import JSEncrypt from "jsencrypt";
import CryptoJS from "crypto-js";

export default {
  data() {
    return {
      // 开始观看时间戳
      startSeekTime: null,
      seekTimer: 0,
      timerControll: null,
    };
  },
  methods: {
    // 定时器
    timerFun() {
      clearInterval(this.timerControll);
      this.timerControll = setInterval(() => {
        this.seekTimer = this.seekTimer + 1;
        if (this.seekTimer % 60 == 0 && this.seekTimer > 0) {
          this.submitStudyTime();
        }
      }, 1000);
    },
    // 清除定时器
    clearTimer() {
      clearInterval(this.timerControll);
    },
    // 提交学时
    submitStudyTime(rid = this.video_id) {
      let strNum = this.startSeekTime * 1000000;
      let reqParam = `start_time=${this.startSeekTime}&end_time=${
        this.startSeekTime + this.seekTimer
      }&resources_id=${rid}&req_time=${new Date().valueOf()}`;
      // console.log(reqParam)
      this.$axios
        .post(`index.php/mobile/column/sync-study-data`, {
          k: this.getRsaCode(strNum),
          data: this.getAesCode(reqParam, strNum),
        })
        .then();
    },
    // RSA加密
    getRsaCode(str) {
      // 注册方法
      let pubKey = `MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCttMz3mwVDHJldIOIo/eeW4THA
            PNjxXHMN/I4E6gt3im3Zf6qS7iGCB7LKEUGSOl1LK89i1LE9GCxCUBq+9OofonnB
            6K126XmFwMZw4gXMqOJzdf4Ad/Chd5r+0gFiNc51GAyTl/f2LVHSL/PnmEzgIk2h
            rZ/edrR8jvBMHfLbsQIDAQAB`; // ES6 模板字符串 引用 rsa 公钥
      let encryptStr = new JSEncrypt();
      encryptStr.setPublicKey(pubKey); // 设置 加密公钥
      let rsaData = encryptStr.encrypt(str.toString()); // 进行加密
      return rsaData;
    },
    // AES加密
    getAesCode(word, keyStr) {
      let srcs = CryptoJS.enc.Utf8.parse(word);
      let key = CryptoJS.enc.Utf8.parse(keyStr);
      var encrypted = CryptoJS.AES.encrypt(srcs, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      });
      return window.btoa(CryptoJS.enc.Base64.stringify(encrypted.ciphertext));
    },
  },
  beforeDestroy() {
    this.clearTimer();
  },
  deactivated() {
    this.clearTimer();
  },
};
